import { useCallback, useContext } from 'react';
import { ServiceLocationContext } from './locationContextValue';

/**
 * Resolve a `v2_location.id` to the location's name (DNKADM-0474): the ledger's Location
 * column and revenue strip showed the bare id ("1"). Returns `null` for an id the roster
 * does not hold (still loading, or no longer a location), so each caller picks its own
 * placeholder, never the raw id.
 *
 * Read tolerantly, like {@link useCalendarZone}: outside a `LocationProvider` nothing
 * resolves. It issues no request of its own.
 */
export function useLocationName(): (id: string | null | undefined) => string | null {
  const ctx = useContext(ServiceLocationContext);
  const locations = ctx?.locations;
  return useCallback(
    (id) => {
      if (id === null || id === undefined) return null;
      return locations?.find((l) => l.id === id)?.name ?? null;
    },
    [locations],
  );
}
